export default __webpack_public_path__ + "static/media/weblogo@2x.4ff73fc9.png";